import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class FreeSpinsInState extends BaseState {

    constructor(stateData) {
        super(stateData);
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('freeSpinsWindow:close', this.onClose, this);
    }

    onClose() {
        if (this.active) {
            this.complete();
        }
    }
}